var map = {
	"./インターネット上の著作物等全般/Media/NHKforSchoolの検索": [
		36318,
		6318
	],
	"./インターネット上の著作物等全般/Media/NHKforSchoolの検索.tsx": [
		36318,
		6318
	],
	"./インターネット上の著作物等全般/Media/ばんぐみ、クリップの選択": [
		94246,
		4246
	],
	"./インターネット上の著作物等全般/Media/ばんぐみ、クリップの選択.tsx": [
		94246,
		4246
	],
	"./インターネット上の著作物等全般/Media/ばんぐみのタイトル": [
		42099,
		2099
	],
	"./インターネット上の著作物等全般/Media/ばんぐみのタイトル.tsx": [
		42099,
		2099
	],
	"./インターネット上の著作物等全般/Media/サブタイトル": [
		94840,
		4840
	],
	"./インターネット上の著作物等全般/Media/サブタイトル.tsx": [
		94840,
		4840
	],
	"./インターネット上の著作物等全般/Media/利用した再生時間の幅": [
		31956,
		1956
	],
	"./インターネット上の著作物等全般/Media/利用した再生時間の幅.tsx": [
		31956,
		1956
	],
	"./インターネット上の著作物等全般/Media/動画投稿サイト名": [
		57070,
		7070
	],
	"./インターネット上の著作物等全般/Media/動画投稿サイト名.tsx": [
		57070,
		7070
	],
	"./インターネット上の著作物等全般/SmallMediaCategorys/【海外含む】学術機関サイト": [
		98815,
		8815
	],
	"./インターネット上の著作物等全般/SmallMediaCategorys/【海外含む】学術機関サイト.tsx": [
		98815,
		8815
	],
	"./インターネット上の著作物等全般/SmallMediaCategorys/テレビ・ラジオ番組のインターネット配信": [
		7198,
		7198
	],
	"./インターネット上の著作物等全般/SmallMediaCategorys/テレビ・ラジオ番組のインターネット配信.tsx": [
		7198,
		7198
	],
	"./インターネット上の著作物等全般/Work/アニメ画像": [
		54845,
		4845
	],
	"./インターネット上の著作物等全般/Work/アニメ画像.tsx": [
		54845,
		4845
	],
	"./インターネット上の著作物等全般/Work/アーティスト名": [
		61155,
		1155
	],
	"./インターネット上の著作物等全般/Work/アーティスト名.tsx": [
		61155,
		1155
	],
	"./インターネット上の著作物等全般/Work/イラスト・美術作品": [
		17350,
		7350
	],
	"./インターネット上の著作物等全般/Work/イラスト・美術作品.tsx": [
		17350,
		7350
	],
	"./インターネット上の著作物等全般/Work/イラスト・美術作品のタイトルまたは概要": [
		36400,
		6400
	],
	"./インターネット上の著作物等全般/Work/イラスト・美術作品のタイトルまたは概要.tsx": [
		36400,
		6400
	],
	"./インターネット上の著作物等全般/Work/イラスト・美術作品の掲載位置": [
		9469,
		9469
	],
	"./インターネット上の著作物等全般/Work/イラスト・美術作品の掲載位置.tsx": [
		9469,
		9469
	],
	"./インターネット上の著作物等全般/Work/コンピュータプログラム記述": [
		21558,
		1558
	],
	"./インターネット上の著作物等全般/Work/コンピュータプログラム記述.tsx": [
		21558,
		1558
	],
	"./インターネット上の著作物等全般/Work/コンピュータプログラム記述のタイトルまたは概要": [
		13546,
		3546
	],
	"./インターネット上の著作物等全般/Work/コンピュータプログラム記述のタイトルまたは概要.tsx": [
		13546,
		3546
	],
	"./インターネット上の著作物等全般/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）": [
		81244,
		1244
	],
	"./インターネット上の著作物等全般/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）.tsx": [
		81244,
		1244
	],
	"./インターネット上の著作物等全般/Work/マンガ": [
		19633,
		9633
	],
	"./インターネット上の著作物等全般/Work/マンガ.tsx": [
		19633,
		9633
	],
	"./インターネット上の著作物等全般/Work/マンガのタイトルまたは概要": [
		75455,
		5455
	],
	"./インターネット上の著作物等全般/Work/マンガのタイトルまたは概要.tsx": [
		75455,
		5455
	],
	"./インターネット上の著作物等全般/Work/作品のカテゴリー": [
		87143,
		7143
	],
	"./インターネット上の著作物等全般/Work/作品のカテゴリー.tsx": [
		87143,
		7143
	],
	"./インターネット上の著作物等全般/Work/写真": [
		43572,
		3572
	],
	"./インターネット上の著作物等全般/Work/写真.tsx": [
		43572,
		3572
	],
	"./インターネット上の著作物等全般/Work/写真のタイトルまたは概要": [
		33547,
		3547
	],
	"./インターネット上の著作物等全般/Work/写真のタイトルまたは概要.tsx": [
		33547,
		3547
	],
	"./インターネット上の著作物等全般/Work/写真の掲載位置": [
		16564,
		6564
	],
	"./インターネット上の著作物等全般/Work/写真の掲載位置.tsx": [
		16564,
		6564
	],
	"./インターネット上の著作物等全般/Work/出典作品名": [
		28572,
		8572
	],
	"./インターネット上の著作物等全般/Work/出典作品名.tsx": [
		28572,
		8572
	],
	"./インターネット上の著作物等全般/Work/分類未選択": [
		11140,
		1140
	],
	"./インターネット上の著作物等全般/Work/分類未選択.tsx": [
		11140,
		1140
	],
	"./インターネット上の著作物等全般/Work/利用したアニメ画像を画像ファイルで添付": [
		50512,
		512
	],
	"./インターネット上の著作物等全般/Work/利用したアニメ画像を画像ファイルで添付.tsx": [
		50512,
		512
	],
	"./インターネット上の著作物等全般/Work/利用したイラスト・美術作品を画像ファイルで添付": [
		63155,
		3155
	],
	"./インターネット上の著作物等全般/Work/利用したイラスト・美術作品を画像ファイルで添付.tsx": [
		63155,
		3155
	],
	"./インターネット上の著作物等全般/Work/利用したマンガを画像ファイルで添付": [
		57958,
		7958
	],
	"./インターネット上の著作物等全般/Work/利用したマンガを画像ファイルで添付.tsx": [
		57958,
		7958
	],
	"./インターネット上の著作物等全般/Work/利用した写真を画像ファイルで添付": [
		27693,
		2344
	],
	"./インターネット上の著作物等全般/Work/利用した写真を画像ファイルで添付.tsx": [
		27693,
		2344
	],
	"./インターネット上の著作物等全般/Work/利用した分量": [
		52008,
		2008
	],
	"./インターネット上の著作物等全般/Work/利用した分量.tsx": [
		52008,
		2008
	],
	"./インターネット上の著作物等全般/Work/利用した図表を画像ファイルで添付": [
		62805,
		2805
	],
	"./インターネット上の著作物等全般/Work/利用した図表を画像ファイルで添付.tsx": [
		62805,
		2805
	],
	"./インターネット上の著作物等全般/Work/利用した箇所": [
		46816,
		6816
	],
	"./インターネット上の著作物等全般/Work/利用した箇所.tsx": [
		46816,
		6816
	],
	"./インターネット上の著作物等全般/Work/動画・映像作品": [
		87699,
		7699
	],
	"./インターネット上の著作物等全般/Work/動画・映像作品.tsx": [
		87699,
		7699
	],
	"./インターネット上の著作物等全般/Work/図表のタイトル（タイトル不明の場合にはその概要）": [
		9224,
		9224
	],
	"./インターネット上の著作物等全般/Work/図表のタイトル（タイトル不明の場合にはその概要）.tsx": [
		9224,
		9224
	],
	"./インターネット上の著作物等全般/Work/図表の掲載位置": [
		34132,
		4132
	],
	"./インターネット上の著作物等全般/Work/図表の掲載位置.tsx": [
		34132,
		4132
	],
	"./インターネット上の著作物等全般/Work/図表（地図を含む）": [
		69104,
		9104
	],
	"./インターネット上の著作物等全般/Work/図表（地図を含む）.tsx": [
		69104,
		9104
	],
	"./インターネット上の著作物等全般/Work/文字・文章": [
		89527,
		9527
	],
	"./インターネット上の著作物等全般/Work/文字・文章.tsx": [
		89527,
		9527
	],
	"./インターネット上の著作物等全般/Work/歌詞・楽譜": [
		22254,
		2254
	],
	"./インターネット上の著作物等全般/Work/歌詞・楽譜.tsx": [
		22254,
		2254
	],
	"./インターネット上の著作物等全般/Work/立体美術作品": [
		20591,
		591
	],
	"./インターネット上の著作物等全般/Work/立体美術作品.tsx": [
		20591,
		591
	],
	"./インターネット上の著作物等全般/Work/立体美術作品の写真": [
		60386,
		386
	],
	"./インターネット上の著作物等全般/Work/立体美術作品の写真.tsx": [
		60386,
		386
	],
	"./インターネット上の著作物等全般/Work/翻訳者名（吹替、字幕作品の場合のみ）": [
		38711,
		8711
	],
	"./インターネット上の著作物等全般/Work/翻訳者名（吹替、字幕作品の場合のみ）.tsx": [
		38711,
		8711
	],
	"./インターネット上の著作物等全般/Work/設問番号又は問題のタイトル": [
		95427,
		5427
	],
	"./インターネット上の著作物等全般/Work/設問番号又は問題のタイトル.tsx": [
		95427,
		5427
	],
	"./インターネット上の著作物等全般/Work/試験問題【1問】": [
		8952,
		8952
	],
	"./インターネット上の著作物等全般/Work/試験問題【1問】.tsx": [
		8952,
		8952
	],
	"./インターネット上の著作物等全般/Work/音声のタイトルまたは概要": [
		69371,
		9371
	],
	"./インターネット上の著作物等全般/Work/音声のタイトルまたは概要.tsx": [
		69371,
		9371
	],
	"./インターネット上の著作物等全般/Work/音声（音楽を含まないもの）": [
		59344,
		9344
	],
	"./インターネット上の著作物等全般/Work/音声（音楽を含まないもの）.tsx": [
		59344,
		9344
	],
	"./インターネット上の著作物等全般/Work/音楽（ミュージックビデオを含む）": [
		5775,
		5775
	],
	"./インターネット上の著作物等全般/Work/音楽（ミュージックビデオを含む）.tsx": [
		5775,
		5775
	],
	"./インターネット上の著作物等全般/bigMediaCategory": [
		64997,
		4997
	],
	"./インターネット上の著作物等全般/bigMediaCategory.tsx": [
		64997,
		4997
	],
	"./冊子、パンフレット等/Media/タイトルまたは概要": [
		9121,
		9121
	],
	"./冊子、パンフレット等/Media/タイトルまたは概要.tsx": [
		9121,
		9121
	],
	"./冊子、パンフレット等/SmallMediaCategorys/発行元：学術機関": [
		90906,
		906
	],
	"./冊子、パンフレット等/SmallMediaCategorys/発行元：学術機関.tsx": [
		90906,
		906
	],
	"./冊子、パンフレット等/Work/アニメ画像": [
		88385,
		8385
	],
	"./冊子、パンフレット等/Work/アニメ画像.tsx": [
		88385,
		8385
	],
	"./冊子、パンフレット等/Work/イラスト・美術作品": [
		52667,
		2667
	],
	"./冊子、パンフレット等/Work/イラスト・美術作品.tsx": [
		52667,
		2667
	],
	"./冊子、パンフレット等/Work/イラスト・美術作品のタイトルまたは概要": [
		25802,
		5802
	],
	"./冊子、パンフレット等/Work/イラスト・美術作品のタイトルまたは概要.tsx": [
		25802,
		5802
	],
	"./冊子、パンフレット等/Work/イラスト・美術作品の掲載位置": [
		99525,
		9525
	],
	"./冊子、パンフレット等/Work/イラスト・美術作品の掲載位置.tsx": [
		99525,
		9525
	],
	"./冊子、パンフレット等/Work/コンピュータプログラム記述": [
		43778,
		3778
	],
	"./冊子、パンフレット等/Work/コンピュータプログラム記述.tsx": [
		43778,
		3778
	],
	"./冊子、パンフレット等/Work/コンピュータプログラム記述のタイトルまたは概要": [
		94668,
		4668
	],
	"./冊子、パンフレット等/Work/コンピュータプログラム記述のタイトルまたは概要.tsx": [
		94668,
		4668
	],
	"./冊子、パンフレット等/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）": [
		70315,
		315
	],
	"./冊子、パンフレット等/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）.tsx": [
		70315,
		315
	],
	"./冊子、パンフレット等/Work/マンガ": [
		43712,
		3712
	],
	"./冊子、パンフレット等/Work/マンガ.tsx": [
		43712,
		3712
	],
	"./冊子、パンフレット等/Work/マンガのタイトルまたは概要": [
		61859,
		1859
	],
	"./冊子、パンフレット等/Work/マンガのタイトルまたは概要.tsx": [
		61859,
		1859
	],
	"./冊子、パンフレット等/Work/写真": [
		20063,
		63
	],
	"./冊子、パンフレット等/Work/写真.tsx": [
		20063,
		63
	],
	"./冊子、パンフレット等/Work/写真のタイトルまたは概要": [
		91487,
		1487
	],
	"./冊子、パンフレット等/Work/写真のタイトルまたは概要.tsx": [
		91487,
		1487
	],
	"./冊子、パンフレット等/Work/写真の掲載位置": [
		17693,
		7693
	],
	"./冊子、パンフレット等/Work/写真の掲載位置.tsx": [
		17693,
		7693
	],
	"./冊子、パンフレット等/Work/出典作品名": [
		28562,
		8562
	],
	"./冊子、パンフレット等/Work/出典作品名.tsx": [
		28562,
		8562
	],
	"./冊子、パンフレット等/Work/分類未選択": [
		59189,
		9189
	],
	"./冊子、パンフレット等/Work/分類未選択.tsx": [
		59189,
		9189
	],
	"./冊子、パンフレット等/Work/利用したアニメ画像を画像ファイルで添付": [
		61079,
		1079
	],
	"./冊子、パンフレット等/Work/利用したアニメ画像を画像ファイルで添付.tsx": [
		61079,
		1079
	],
	"./冊子、パンフレット等/Work/利用したイラスト・美術作品を画像ファイルで添付": [
		56244,
		3507
	],
	"./冊子、パンフレット等/Work/利用したイラスト・美術作品を画像ファイルで添付.tsx": [
		56244,
		3507
	],
	"./冊子、パンフレット等/Work/利用したマンガを画像ファイルで添付": [
		34563,
		4563
	],
	"./冊子、パンフレット等/Work/利用したマンガを画像ファイルで添付.tsx": [
		34563,
		4563
	],
	"./冊子、パンフレット等/Work/利用した写真を画像ファイルで添付": [
		77542,
		7542
	],
	"./冊子、パンフレット等/Work/利用した写真を画像ファイルで添付.tsx": [
		77542,
		7542
	],
	"./冊子、パンフレット等/Work/利用した図表を画像ファイルで添付": [
		61176,
		1176
	],
	"./冊子、パンフレット等/Work/利用した図表を画像ファイルで添付.tsx": [
		61176,
		1176
	],
	"./冊子、パンフレット等/Work/利用箇所": [
		15393,
		5393
	],
	"./冊子、パンフレット等/Work/利用箇所.tsx": [
		15393,
		5393
	],
	"./冊子、パンフレット等/Work/図表のタイトル（タイトル不明の場合にはその概要）": [
		89341,
		9341
	],
	"./冊子、パンフレット等/Work/図表のタイトル（タイトル不明の場合にはその概要）.tsx": [
		89341,
		9341
	],
	"./冊子、パンフレット等/Work/図表の掲載位置": [
		55536,
		5536
	],
	"./冊子、パンフレット等/Work/図表の掲載位置.tsx": [
		55536,
		5536
	],
	"./冊子、パンフレット等/Work/図表（地図を含む）": [
		59010,
		9010
	],
	"./冊子、パンフレット等/Work/図表（地図を含む）.tsx": [
		59010,
		9010
	],
	"./冊子、パンフレット等/Work/文字・文章": [
		32957,
		2957
	],
	"./冊子、パンフレット等/Work/文字・文章.tsx": [
		32957,
		2957
	],
	"./冊子、パンフレット等/Work/歌詞・楽譜": [
		4658,
		4658
	],
	"./冊子、パンフレット等/Work/歌詞・楽譜.tsx": [
		4658,
		4658
	],
	"./冊子、パンフレット等/Work/立体美術作品": [
		89511,
		7625
	],
	"./冊子、パンフレット等/Work/立体美術作品.tsx": [
		89511,
		7625
	],
	"./冊子、パンフレット等/Work/立体美術作品の写真": [
		40525,
		525
	],
	"./冊子、パンフレット等/Work/立体美術作品の写真.tsx": [
		40525,
		525
	],
	"./冊子、パンフレット等/Work/設問番号又は問題のタイトル": [
		45135,
		5135
	],
	"./冊子、パンフレット等/Work/設問番号又は問題のタイトル.tsx": [
		45135,
		5135
	],
	"./冊子、パンフレット等/Work/試験問題【1問】": [
		37639,
		7639
	],
	"./冊子、パンフレット等/Work/試験問題【1問】.tsx": [
		37639,
		7639
	],
	"./冊子、パンフレット等/bigMediaCategory": [
		35587,
		5587
	],
	"./冊子、パンフレット等/bigMediaCategory.tsx": [
		35587,
		5587
	],
	"./副読本、副教材等の教材/Media/ISBNコード": [
		70536,
		536
	],
	"./副読本、副教材等の教材/Media/ISBNコード.tsx": [
		70536,
		536
	],
	"./副読本、副教材等の教材/Work/アニメ画像": [
		73931,
		3931
	],
	"./副読本、副教材等の教材/Work/アニメ画像.tsx": [
		73931,
		3931
	],
	"./副読本、副教材等の教材/Work/アーティスト名": [
		24640,
		4640
	],
	"./副読本、副教材等の教材/Work/アーティスト名.tsx": [
		24640,
		4640
	],
	"./副読本、副教材等の教材/Work/イラスト・美術作品": [
		12701,
		2701
	],
	"./副読本、副教材等の教材/Work/イラスト・美術作品.tsx": [
		12701,
		2701
	],
	"./副読本、副教材等の教材/Work/イラスト・美術作品のタイトルまたは概要": [
		34573,
		4573
	],
	"./副読本、副教材等の教材/Work/イラスト・美術作品のタイトルまたは概要.tsx": [
		34573,
		4573
	],
	"./副読本、副教材等の教材/Work/イラスト・美術作品の掲載位置": [
		32052,
		2052
	],
	"./副読本、副教材等の教材/Work/イラスト・美術作品の掲載位置.tsx": [
		32052,
		2052
	],
	"./副読本、副教材等の教材/Work/コンピュータプログラム記述": [
		79592,
		9592
	],
	"./副読本、副教材等の教材/Work/コンピュータプログラム記述.tsx": [
		79592,
		9592
	],
	"./副読本、副教材等の教材/Work/コンピュータプログラム記述のタイトルまたは概要": [
		32418,
		2418
	],
	"./副読本、副教材等の教材/Work/コンピュータプログラム記述のタイトルまたは概要.tsx": [
		32418,
		2418
	],
	"./副読本、副教材等の教材/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）": [
		7035,
		7035
	],
	"./副読本、副教材等の教材/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）.tsx": [
		7035,
		7035
	],
	"./副読本、副教材等の教材/Work/マンガ": [
		57452,
		7452
	],
	"./副読本、副教材等の教材/Work/マンガ.tsx": [
		57452,
		7452
	],
	"./副読本、副教材等の教材/Work/マンガのタイトルまたは概要": [
		4754,
		4754
	],
	"./副読本、副教材等の教材/Work/マンガのタイトルまたは概要.tsx": [
		4754,
		4754
	],
	"./副読本、副教材等の教材/Work/作品のカテゴリー": [
		43202,
		3202
	],
	"./副読本、副教材等の教材/Work/作品のカテゴリー.tsx": [
		43202,
		3202
	],
	"./副読本、副教材等の教材/Work/写真": [
		72203,
		2203
	],
	"./副読本、副教材等の教材/Work/写真.tsx": [
		72203,
		2203
	],
	"./副読本、副教材等の教材/Work/写真のタイトルまたは概要": [
		78782,
		8782
	],
	"./副読本、副教材等の教材/Work/写真のタイトルまたは概要.tsx": [
		78782,
		8782
	],
	"./副読本、副教材等の教材/Work/写真の掲載位置": [
		88272,
		8272
	],
	"./副読本、副教材等の教材/Work/写真の掲載位置.tsx": [
		88272,
		8272
	],
	"./副読本、副教材等の教材/Work/出典作品名": [
		70477,
		477
	],
	"./副読本、副教材等の教材/Work/出典作品名.tsx": [
		70477,
		477
	],
	"./副読本、副教材等の教材/Work/分類未選択": [
		19095,
		9095
	],
	"./副読本、副教材等の教材/Work/分類未選択.tsx": [
		19095,
		9095
	],
	"./副読本、副教材等の教材/Work/利用したアニメ画像を画像ファイルで添付": [
		85201,
		5201
	],
	"./副読本、副教材等の教材/Work/利用したアニメ画像を画像ファイルで添付.tsx": [
		85201,
		5201
	],
	"./副読本、副教材等の教材/Work/利用したイラスト・美術作品を画像ファイルで添付": [
		69336,
		9336
	],
	"./副読本、副教材等の教材/Work/利用したイラスト・美術作品を画像ファイルで添付.tsx": [
		69336,
		9336
	],
	"./副読本、副教材等の教材/Work/利用したマンガを画像ファイルで添付": [
		89320,
		9320
	],
	"./副読本、副教材等の教材/Work/利用したマンガを画像ファイルで添付.tsx": [
		89320,
		9320
	],
	"./副読本、副教材等の教材/Work/利用した写真を画像ファイルで添付": [
		12966,
		2966
	],
	"./副読本、副教材等の教材/Work/利用した写真を画像ファイルで添付.tsx": [
		12966,
		2966
	],
	"./副読本、副教材等の教材/Work/利用した分量": [
		83503,
		3503
	],
	"./副読本、副教材等の教材/Work/利用した分量.tsx": [
		83503,
		3503
	],
	"./副読本、副教材等の教材/Work/利用した図表を画像ファイルで添付": [
		48570,
		2145
	],
	"./副読本、副教材等の教材/Work/利用した図表を画像ファイルで添付.tsx": [
		48570,
		2145
	],
	"./副読本、副教材等の教材/Work/利用箇所": [
		57193,
		7193
	],
	"./副読本、副教材等の教材/Work/利用箇所.tsx": [
		57193,
		7193
	],
	"./副読本、副教材等の教材/Work/動画・映像作品": [
		87941,
		7941
	],
	"./副読本、副教材等の教材/Work/動画・映像作品.tsx": [
		87941,
		7941
	],
	"./副読本、副教材等の教材/Work/図表のタイトル（タイトル不明の場合にはその概要）": [
		41369,
		1369
	],
	"./副読本、副教材等の教材/Work/図表のタイトル（タイトル不明の場合にはその概要）.tsx": [
		41369,
		1369
	],
	"./副読本、副教材等の教材/Work/図表の掲載位置": [
		4681,
		4681
	],
	"./副読本、副教材等の教材/Work/図表の掲載位置.tsx": [
		4681,
		4681
	],
	"./副読本、副教材等の教材/Work/図表（地図を含む）": [
		54996,
		4996
	],
	"./副読本、副教材等の教材/Work/図表（地図を含む）.tsx": [
		54996,
		4996
	],
	"./副読本、副教材等の教材/Work/文字・文章": [
		87195,
		7195
	],
	"./副読本、副教材等の教材/Work/文字・文章.tsx": [
		87195,
		7195
	],
	"./副読本、副教材等の教材/Work/歌詞・楽譜": [
		43784,
		3784
	],
	"./副読本、副教材等の教材/Work/歌詞・楽譜.tsx": [
		43784,
		3784
	],
	"./副読本、副教材等の教材/Work/立体美術作品": [
		90436,
		436
	],
	"./副読本、副教材等の教材/Work/立体美術作品.tsx": [
		90436,
		436
	],
	"./副読本、副教材等の教材/Work/立体美術作品の写真": [
		3545,
		3545
	],
	"./副読本、副教材等の教材/Work/立体美術作品の写真.tsx": [
		3545,
		3545
	],
	"./副読本、副教材等の教材/Work/設問番号又は問題のタイトル": [
		77067,
		7067
	],
	"./副読本、副教材等の教材/Work/設問番号又は問題のタイトル.tsx": [
		77067,
		7067
	],
	"./副読本、副教材等の教材/Work/試験問題【1問】": [
		559,
		559
	],
	"./副読本、副教材等の教材/Work/試験問題【1問】.tsx": [
		559,
		559
	],
	"./副読本、副教材等の教材/Work/音声のタイトルまたは概要": [
		72129,
		2129
	],
	"./副読本、副教材等の教材/Work/音声のタイトルまたは概要.tsx": [
		72129,
		2129
	],
	"./副読本、副教材等の教材/Work/音声（音楽を含まないもの）": [
		70971,
		971
	],
	"./副読本、副教材等の教材/Work/音声（音楽を含まないもの）.tsx": [
		70971,
		971
	],
	"./副読本、副教材等の教材/Work/音楽（ミュージックビデオを含む）": [
		3473,
		3473
	],
	"./副読本、副教材等の教材/Work/音楽（ミュージックビデオを含む）.tsx": [
		3473,
		3473
	],
	"./副読本、副教材等の教材/bigMediaCategory": [
		47040,
		7040
	],
	"./副読本、副教材等の教材/bigMediaCategory.tsx": [
		47040,
		7040
	],
	"./放送（テレビ・ラジオ）/Media/NHKforSchoolの検索": [
		76715,
		6715
	],
	"./放送（テレビ・ラジオ）/Media/NHKforSchoolの検索.tsx": [
		76715,
		6715
	],
	"./放送（テレビ・ラジオ）/Media/ばんぐみ、クリップの選択": [
		73242,
		3242
	],
	"./放送（テレビ・ラジオ）/Media/ばんぐみ、クリップの選択.tsx": [
		73242,
		3242
	],
	"./放送（テレビ・ラジオ）/Media/ばんぐみのタイトル": [
		74025,
		4025
	],
	"./放送（テレビ・ラジオ）/Media/ばんぐみのタイトル.tsx": [
		74025,
		4025
	],
	"./放送（テレビ・ラジオ）/Media/サブタイトル": [
		58930,
		8930
	],
	"./放送（テレビ・ラジオ）/Media/サブタイトル.tsx": [
		58930,
		8930
	],
	"./放送（テレビ・ラジオ）/Media/サブタイトル、話数": [
		82871,
		2871
	],
	"./放送（テレビ・ラジオ）/Media/サブタイトル、話数.tsx": [
		82871,
		2871
	],
	"./放送（テレビ・ラジオ）/Media/利用した再生時間の幅": [
		87545,
		7545
	],
	"./放送（テレビ・ラジオ）/Media/利用した再生時間の幅.tsx": [
		87545,
		7545
	],
	"./放送（テレビ・ラジオ）/Work/作品のカテゴリー": [
		3297,
		3297
	],
	"./放送（テレビ・ラジオ）/Work/作品のカテゴリー.tsx": [
		3297,
		3297
	],
	"./放送（テレビ・ラジオ）/Work/分類未選択": [
		74436,
		4436
	],
	"./放送（テレビ・ラジオ）/Work/分類未選択.tsx": [
		74436,
		4436
	],
	"./放送（テレビ・ラジオ）/Work/利用した分量": [
		30001,
		1
	],
	"./放送（テレビ・ラジオ）/Work/利用した分量.tsx": [
		30001,
		1
	],
	"./放送（テレビ・ラジオ）/bigMediaCategory": [
		83761,
		3761
	],
	"./放送（テレビ・ラジオ）/bigMediaCategory.tsx": [
		83761,
		3761
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Media/使用学年": [
		22649,
		2649
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Media/使用学年.tsx": [
		22649,
		2649
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Media/指導書のサブタイトルや教材名": [
		14772,
		4772
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Media/指導書のサブタイトルや教材名.tsx": [
		14772,
		4772
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Media/検定教科書名": [
		92054,
		2054
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Media/検定教科書名.tsx": [
		92054,
		2054
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Media/検定教科書番号から自動入力": [
		25525,
		5525
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Media/検定教科書番号から自動入力.tsx": [
		25525,
		5525
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Media/検定済年度": [
		42474,
		2474
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Media/検定済年度.tsx": [
		42474,
		2474
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/Web上に収録": [
		27203,
		7203
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/Web上に収録.tsx": [
		27203,
		7203
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/指導者用デジタル教科書": [
		37851,
		7851
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/指導者用デジタル教科書.tsx": [
		37851,
		7851
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/指導者用デジタル教科書上からリンクして利用するコンテンツ": [
		93242,
		7012
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/指導者用デジタル教科書上からリンクして利用するコンテンツ.tsx": [
		93242,
		7012
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/指導者用デジタル教科書上の著作物": [
		16126,
		6126
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/指導者用デジタル教科書上の著作物.tsx": [
		16126,
		6126
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書上からリンクして利用するコンテンツ": [
		92742,
		2742
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書上からリンクして利用するコンテンツ.tsx": [
		92742,
		2742
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書上の二次元コードやURLからアクセスして利用するコンテンツ": [
		25172,
		5172
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書上の二次元コードやURLからアクセスして利用するコンテンツ.tsx": [
		25172,
		5172
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書付属教材上の二次元コードやURLからアクセスして利用するコンテンツ": [
		12849,
		2849
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書付属教材上の二次元コードやURLからアクセスして利用するコンテンツ.tsx": [
		12849,
		2849
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書付属教材（「指導者用デジタル教科書」を除く）": [
		14028,
		4028
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書付属教材（「指導者用デジタル教科書」を除く）.tsx": [
		14028,
		4028
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書画面上の著作物": [
		3908,
		3908
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書画面上の著作物.tsx": [
		3908,
		3908
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書紙面上の著作物": [
		90625,
		625
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書紙面上の著作物.tsx": [
		90625,
		625
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書附属教材上の著作物": [
		66709,
		6709
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書附属教材上の著作物.tsx": [
		66709,
		6709
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書（各種分冊）": [
		84573,
		4247
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教師用指導書（各種分冊）.tsx": [
		84573,
		4247
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教科書以外の部分": [
		99495,
		9495
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教科書以外の部分.tsx": [
		99495,
		9495
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教科書部分": [
		82010,
		2010
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/SmallMediaCategorys/教科書部分.tsx": [
		82010,
		2010
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/アニメ画像": [
		88912,
		8912
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/アニメ画像.tsx": [
		88912,
		8912
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/アーティスト名": [
		21864,
		1864
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/アーティスト名.tsx": [
		21864,
		1864
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/イラスト・美術作品": [
		74876,
		4876
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/イラスト・美術作品.tsx": [
		74876,
		4876
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/イラスト・美術作品のタイトルまたは概要": [
		9452,
		9452
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/イラスト・美術作品のタイトルまたは概要.tsx": [
		9452,
		9452
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/イラスト・美術作品の掲載位置": [
		35313,
		5313
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/イラスト・美術作品の掲載位置.tsx": [
		35313,
		5313
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/コンピュータプログラム記述": [
		12657,
		2657
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/コンピュータプログラム記述.tsx": [
		12657,
		2657
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/コンピュータプログラム記述のタイトルまたは概要": [
		98076,
		8076
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/コンピュータプログラム記述のタイトルまたは概要.tsx": [
		98076,
		8076
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）": [
		22945,
		2945
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）.tsx": [
		22945,
		2945
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/マンガ": [
		72968,
		2968
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/マンガ.tsx": [
		72968,
		2968
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/マンガのタイトルまたは概要": [
		62356,
		2356
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/マンガのタイトルまたは概要.tsx": [
		62356,
		2356
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/作品のカテゴリー": [
		24615,
		4615
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/作品のカテゴリー.tsx": [
		24615,
		4615
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/写真": [
		39663,
		9663
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/写真.tsx": [
		39663,
		9663
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/写真のタイトルまたは概要": [
		12821,
		2821
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/写真のタイトルまたは概要.tsx": [
		12821,
		2821
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/写真の掲載位置": [
		44726,
		4726
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/写真の掲載位置.tsx": [
		44726,
		4726
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/出典作品名": [
		85380,
		5380
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/出典作品名.tsx": [
		85380,
		5380
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/分類未選択": [
		38938,
		8938
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/分類未選択.tsx": [
		38938,
		8938
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用したアニメ画像を画像ファイルで添付": [
		81559,
		1559
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用したアニメ画像を画像ファイルで添付.tsx": [
		81559,
		1559
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用したイラスト・美術作品を画像ファイルで添付": [
		72942,
		2942
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用したイラスト・美術作品を画像ファイルで添付.tsx": [
		72942,
		2942
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用したマンガを画像ファイルで添付": [
		16591,
		6591
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用したマンガを画像ファイルで添付.tsx": [
		16591,
		6591
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用した写真を画像ファイルで添付": [
		87895,
		7895
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用した写真を画像ファイルで添付.tsx": [
		87895,
		7895
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用した分量": [
		53389,
		3389
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用した分量.tsx": [
		53389,
		3389
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用した図表を画像ファイルで添付": [
		16383,
		6383
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用した図表を画像ファイルで添付.tsx": [
		16383,
		6383
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用コンテンツの名称、タイトル": [
		63932,
		3932
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用コンテンツの名称、タイトル.tsx": [
		63932,
		3932
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用箇所": [
		22982,
		2982
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/利用箇所.tsx": [
		22982,
		2982
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/動画・映像作品": [
		47022,
		7022
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/動画・映像作品.tsx": [
		47022,
		7022
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/図表のタイトル（タイトル不明の場合にはその概要）": [
		39432,
		9432
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/図表のタイトル（タイトル不明の場合にはその概要）.tsx": [
		39432,
		9432
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/図表の掲載位置": [
		10279,
		279
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/図表の掲載位置.tsx": [
		10279,
		279
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/図表（地図を含む）": [
		26724,
		6724
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/図表（地図を含む）.tsx": [
		26724,
		6724
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/文字・文章": [
		85953,
		5953
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/文字・文章.tsx": [
		85953,
		5953
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/歌詞・楽譜": [
		39146,
		9146
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/歌詞・楽譜.tsx": [
		39146,
		9146
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/立体美術作品": [
		68882,
		8882
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/立体美術作品.tsx": [
		68882,
		8882
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/立体美術作品の写真": [
		36391,
		6391
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/立体美術作品の写真.tsx": [
		36391,
		6391
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/設問番号又は問題のタイトル": [
		91639,
		1639
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/設問番号又は問題のタイトル.tsx": [
		91639,
		1639
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/試験問題【1問】": [
		44766,
		4766
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/試験問題【1問】.tsx": [
		44766,
		4766
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/音声のタイトルまたは概要": [
		29476,
		9476
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/音声のタイトルまたは概要.tsx": [
		29476,
		9476
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/音声（音楽を含まないもの）": [
		7244,
		7244
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/音声（音楽を含まないもの）.tsx": [
		7244,
		7244
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/音楽": [
		30465,
		465
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/音楽.tsx": [
		30465,
		465
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/音楽（ミュージックビデオを含む）": [
		30002,
		2
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/Work/音楽（ミュージックビデオを含む）.tsx": [
		30002,
		2
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/bigMediaCategory": [
		9742,
		9742
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/bigMediaCategory.tsx": [
		9742,
		9742
	],
	"./新聞/Work/Webページ上の1記事全体を送信": [
		58465,
		8465
	],
	"./新聞/Work/Webページ上の1記事全体を送信.tsx": [
		58465,
		8465
	],
	"./新聞/Work/アニメ画像": [
		42404,
		2404
	],
	"./新聞/Work/アニメ画像.tsx": [
		42404,
		2404
	],
	"./新聞/Work/アーティスト名": [
		45796,
		5796
	],
	"./新聞/Work/アーティスト名.tsx": [
		45796,
		5796
	],
	"./新聞/Work/イラスト・美術作品": [
		86746,
		6746
	],
	"./新聞/Work/イラスト・美術作品.tsx": [
		86746,
		6746
	],
	"./新聞/Work/イラスト・美術作品のタイトルまたは概要": [
		8094,
		8094
	],
	"./新聞/Work/イラスト・美術作品のタイトルまたは概要.tsx": [
		8094,
		8094
	],
	"./新聞/Work/イラスト・美術作品の掲載位置": [
		18381,
		8381
	],
	"./新聞/Work/イラスト・美術作品の掲載位置.tsx": [
		18381,
		8381
	],
	"./新聞/Work/コンピュータプログラム記述": [
		8246,
		8246
	],
	"./新聞/Work/コンピュータプログラム記述.tsx": [
		8246,
		8246
	],
	"./新聞/Work/コンピュータプログラム記述のタイトルまたは概要": [
		14904,
		4904
	],
	"./新聞/Work/コンピュータプログラム記述のタイトルまたは概要.tsx": [
		14904,
		4904
	],
	"./新聞/Work/マンガ": [
		82369,
		2369
	],
	"./新聞/Work/マンガ.tsx": [
		82369,
		2369
	],
	"./新聞/Work/マンガのタイトルまたは概要": [
		58132,
		8132
	],
	"./新聞/Work/マンガのタイトルまたは概要.tsx": [
		58132,
		8132
	],
	"./新聞/Work/作品のカテゴリー": [
		89858,
		9858
	],
	"./新聞/Work/作品のカテゴリー.tsx": [
		89858,
		9858
	],
	"./新聞/Work/写真": [
		46000,
		6000
	],
	"./新聞/Work/写真.tsx": [
		46000,
		6000
	],
	"./新聞/Work/写真のタイトルまたは概要": [
		53986,
		3986
	],
	"./新聞/Work/写真のタイトルまたは概要.tsx": [
		53986,
		3986
	],
	"./新聞/Work/写真の掲載位置": [
		30500,
		500
	],
	"./新聞/Work/写真の掲載位置.tsx": [
		30500,
		500
	],
	"./新聞/Work/出典作品名": [
		40530,
		530
	],
	"./新聞/Work/出典作品名.tsx": [
		40530,
		530
	],
	"./新聞/Work/分類未選択": [
		51567,
		1567
	],
	"./新聞/Work/分類未選択.tsx": [
		51567,
		1567
	],
	"./新聞/Work/利用したアニメ画像を画像ファイルで添付": [
		18130,
		8130
	],
	"./新聞/Work/利用したアニメ画像を画像ファイルで添付.tsx": [
		18130,
		8130
	],
	"./新聞/Work/利用したイラスト・美術作品を画像ファイルで添付": [
		40716,
		716
	],
	"./新聞/Work/利用したイラスト・美術作品を画像ファイルで添付.tsx": [
		40716,
		716
	],
	"./新聞/Work/利用したマンガを画像ファイルで添付": [
		16476,
		6476
	],
	"./新聞/Work/利用したマンガを画像ファイルで添付.tsx": [
		16476,
		6476
	],
	"./新聞/Work/利用した写真を画像ファイルで添付": [
		59277,
		9277
	],
	"./新聞/Work/利用した写真を画像ファイルで添付.tsx": [
		59277,
		9277
	],
	"./新聞/Work/利用した分量": [
		75193,
		5193
	],
	"./新聞/Work/利用した分量.tsx": [
		75193,
		5193
	],
	"./新聞/Work/利用した図表を画像ファイルで添付": [
		13306,
		6244
	],
	"./新聞/Work/利用した図表を画像ファイルで添付.tsx": [
		13306,
		6244
	],
	"./新聞/Work/動画・映像作品": [
		53526,
		3526
	],
	"./新聞/Work/動画・映像作品.tsx": [
		53526,
		3526
	],
	"./新聞/Work/図表のタイトル（タイトル不明の場合にはその概要）": [
		7310,
		7310
	],
	"./新聞/Work/図表のタイトル（タイトル不明の場合にはその概要）.tsx": [
		7310,
		7310
	],
	"./新聞/Work/図表の掲載位置": [
		95313,
		7091
	],
	"./新聞/Work/図表の掲載位置.tsx": [
		95313,
		7091
	],
	"./新聞/Work/図表（地図を含む）": [
		36566,
		6566
	],
	"./新聞/Work/図表（地図を含む）.tsx": [
		36566,
		6566
	],
	"./新聞/Work/文字・文章": [
		8521,
		8521
	],
	"./新聞/Work/文字・文章.tsx": [
		8521,
		8521
	],
	"./新聞/Work/歌詞・楽譜": [
		81935,
		1935
	],
	"./新聞/Work/歌詞・楽譜.tsx": [
		81935,
		1935
	],
	"./新聞/Work/立体美術作品": [
		15711,
		5711
	],
	"./新聞/Work/立体美術作品.tsx": [
		15711,
		5711
	],
	"./新聞/Work/立体美術作品の写真": [
		49436,
		9436
	],
	"./新聞/Work/立体美術作品の写真.tsx": [
		49436,
		9436
	],
	"./新聞/Work/記事の全体を送信": [
		23500,
		3500
	],
	"./新聞/Work/記事の全体を送信.tsx": [
		23500,
		3500
	],
	"./新聞/Work/設問番号又は問題のタイトル": [
		93113,
		3113
	],
	"./新聞/Work/設問番号又は問題のタイトル.tsx": [
		93113,
		3113
	],
	"./新聞/Work/試験問題【1問】": [
		21532,
		1532
	],
	"./新聞/Work/試験問題【1問】.tsx": [
		21532,
		1532
	],
	"./新聞/Work/音声のタイトルまたは概要": [
		60465,
		8530
	],
	"./新聞/Work/音声のタイトルまたは概要.tsx": [
		60465,
		8530
	],
	"./新聞/Work/音声（音楽を含まないもの）": [
		26839,
		6839
	],
	"./新聞/Work/音声（音楽を含まないもの）.tsx": [
		26839,
		6839
	],
	"./新聞/Work/音楽（ミュージックビデオを含む）": [
		2680,
		2680
	],
	"./新聞/Work/音楽（ミュージックビデオを含む）.tsx": [
		2680,
		2680
	],
	"./新聞/bigMediaCategory": [
		17431,
		7431
	],
	"./新聞/bigMediaCategory.tsx": [
		17431,
		7431
	],
	"./映像DVD・ブルーレイ等/Media/ASINコード": [
		96559,
		6559
	],
	"./映像DVD・ブルーレイ等/Media/ASINコード.tsx": [
		96559,
		6559
	],
	"./映像DVD・ブルーレイ等/Media/アルバム・シングルのタイトル": [
		10093,
		93
	],
	"./映像DVD・ブルーレイ等/Media/アルバム・シングルのタイトル.tsx": [
		10093,
		93
	],
	"./映像DVD・ブルーレイ等/Media/サブタイトル、話数等": [
		10463,
		463
	],
	"./映像DVD・ブルーレイ等/Media/サブタイトル、話数等.tsx": [
		10463,
		463
	],
	"./映像DVD・ブルーレイ等/Media/レコード商品番号": [
		90728,
		728
	],
	"./映像DVD・ブルーレイ等/Media/レコード商品番号.tsx": [
		90728,
		728
	],
	"./映像DVD・ブルーレイ等/Media/利用した箇所": [
		3005,
		3005
	],
	"./映像DVD・ブルーレイ等/Media/利用した箇所.tsx": [
		3005,
		3005
	],
	"./映像DVD・ブルーレイ等/Media/放送局、映像制作会社、団体等の名称": [
		2595,
		2595
	],
	"./映像DVD・ブルーレイ等/Media/放送局、映像制作会社、団体等の名称.tsx": [
		2595,
		2595
	],
	"./映像DVD・ブルーレイ等/SmallMediaCategorys/テレビ番組（アニメを除く）": [
		29607,
		9607
	],
	"./映像DVD・ブルーレイ等/SmallMediaCategorys/テレビ番組（アニメを除く）.tsx": [
		29607,
		9607
	],
	"./映像DVD・ブルーレイ等/Work/アーティスト名": [
		43720,
		3720
	],
	"./映像DVD・ブルーレイ等/Work/アーティスト名.tsx": [
		43720,
		3720
	],
	"./映像DVD・ブルーレイ等/Work/トラック番号": [
		80135,
		135
	],
	"./映像DVD・ブルーレイ等/Work/トラック番号.tsx": [
		80135,
		135
	],
	"./映像DVD・ブルーレイ等/Work/分類未選択": [
		81603,
		1603
	],
	"./映像DVD・ブルーレイ等/Work/分類未選択.tsx": [
		81603,
		1603
	],
	"./映像DVD・ブルーレイ等/bigMediaCategory": [
		45422,
		5422
	],
	"./映像DVD・ブルーレイ等/bigMediaCategory.tsx": [
		45422,
		5422
	],
	"./書籍・本/Media/ISBNコード": [
		54445,
		4445
	],
	"./書籍・本/Media/ISBNコード.tsx": [
		54445,
		4445
	],
	"./書籍・本/SmallMediaCategorys/学校専売品": [
		18729,
		8729
	],
	"./書籍・本/SmallMediaCategorys/学校専売品.tsx": [
		18729,
		8729
	],
	"./書籍・本/SmallMediaCategorys/市販": [
		77580,
		7580
	],
	"./書籍・本/SmallMediaCategorys/市販.tsx": [
		77580,
		7580
	],
	"./書籍・本/SmallMediaCategorys/教育機関が発行（論文集等）": [
		2183,
		2183
	],
	"./書籍・本/SmallMediaCategorys/教育機関が発行（論文集等）.tsx": [
		2183,
		2183
	],
	"./書籍・本/SmallMediaCategorys/脚本・シナリオ・台本": [
		66810,
		6810
	],
	"./書籍・本/SmallMediaCategorys/脚本・シナリオ・台本.tsx": [
		66810,
		6810
	],
	"./書籍・本/Work/アニメ画像": [
		72570,
		2570
	],
	"./書籍・本/Work/アニメ画像.tsx": [
		72570,
		2570
	],
	"./書籍・本/Work/アーティスト名": [
		60586,
		586
	],
	"./書籍・本/Work/アーティスト名.tsx": [
		60586,
		586
	],
	"./書籍・本/Work/イラスト・美術作品": [
		61685,
		1685
	],
	"./書籍・本/Work/イラスト・美術作品.tsx": [
		61685,
		1685
	],
	"./書籍・本/Work/イラスト・美術作品のタイトルまたは概要": [
		31887,
		1887
	],
	"./書籍・本/Work/イラスト・美術作品のタイトルまたは概要.tsx": [
		31887,
		1887
	],
	"./書籍・本/Work/イラスト・美術作品の掲載位置": [
		30907,
		907
	],
	"./書籍・本/Work/イラスト・美術作品の掲載位置.tsx": [
		30907,
		907
	],
	"./書籍・本/Work/コンピュータプログラム記述": [
		17107,
		7107
	],
	"./書籍・本/Work/コンピュータプログラム記述.tsx": [
		17107,
		7107
	],
	"./書籍・本/Work/コンピュータプログラム記述のタイトルまたは概要": [
		79660,
		9660
	],
	"./書籍・本/Work/コンピュータプログラム記述のタイトルまたは概要.tsx": [
		79660,
		9660
	],
	"./書籍・本/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）": [
		62264,
		2264
	],
	"./書籍・本/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）.tsx": [
		62264,
		2264
	],
	"./書籍・本/Work/マンガ": [
		33842,
		3842
	],
	"./書籍・本/Work/マンガ.tsx": [
		33842,
		3842
	],
	"./書籍・本/Work/マンガのタイトルまたは概要": [
		41236,
		1236
	],
	"./書籍・本/Work/マンガのタイトルまたは概要.tsx": [
		41236,
		1236
	],
	"./書籍・本/Work/作品のカテゴリー": [
		72445,
		2445
	],
	"./書籍・本/Work/作品のカテゴリー.tsx": [
		72445,
		2445
	],
	"./書籍・本/Work/写真": [
		16497,
		6497
	],
	"./書籍・本/Work/写真.tsx": [
		16497,
		6497
	],
	"./書籍・本/Work/写真のタイトルまたは概要": [
		89097,
		9097
	],
	"./書籍・本/Work/写真のタイトルまたは概要.tsx": [
		89097,
		9097
	],
	"./書籍・本/Work/写真の掲載位置": [
		59917,
		9917
	],
	"./書籍・本/Work/写真の掲載位置.tsx": [
		59917,
		9917
	],
	"./書籍・本/Work/出典作品名": [
		52607,
		2607
	],
	"./書籍・本/Work/出典作品名.tsx": [
		52607,
		2607
	],
	"./書籍・本/Work/分類未選択": [
		51765,
		1765
	],
	"./書籍・本/Work/分類未選択.tsx": [
		51765,
		1765
	],
	"./書籍・本/Work/利用したアニメ画像を画像ファイルで添付": [
		3739,
		3739
	],
	"./書籍・本/Work/利用したアニメ画像を画像ファイルで添付.tsx": [
		3739,
		3739
	],
	"./書籍・本/Work/利用したイラスト・美術作品を画像ファイルで添付": [
		72878,
		2878
	],
	"./書籍・本/Work/利用したイラスト・美術作品を画像ファイルで添付.tsx": [
		72878,
		2878
	],
	"./書籍・本/Work/利用したマンガを画像ファイルで添付": [
		79419,
		9419
	],
	"./書籍・本/Work/利用したマンガを画像ファイルで添付.tsx": [
		79419,
		9419
	],
	"./書籍・本/Work/利用した写真を画像ファイルで添付": [
		70202,
		202
	],
	"./書籍・本/Work/利用した写真を画像ファイルで添付.tsx": [
		70202,
		202
	],
	"./書籍・本/Work/利用した分量": [
		55456,
		5456
	],
	"./書籍・本/Work/利用した分量.tsx": [
		55456,
		5456
	],
	"./書籍・本/Work/利用した図表を画像ファイルで添付": [
		75283,
		5283
	],
	"./書籍・本/Work/利用した図表を画像ファイルで添付.tsx": [
		75283,
		5283
	],
	"./書籍・本/Work/利用コンテンツの名称、タイトル": [
		55720,
		5720
	],
	"./書籍・本/Work/利用コンテンツの名称、タイトル.tsx": [
		55720,
		5720
	],
	"./書籍・本/Work/利用箇所": [
		87049,
		7049
	],
	"./書籍・本/Work/利用箇所.tsx": [
		87049,
		7049
	],
	"./書籍・本/Work/動画・映像作品": [
		9260,
		9260
	],
	"./書籍・本/Work/動画・映像作品.tsx": [
		9260,
		9260
	],
	"./書籍・本/Work/図表のタイトル（タイトル不明の場合にはその概要）": [
		47354,
		7354
	],
	"./書籍・本/Work/図表のタイトル（タイトル不明の場合にはその概要）.tsx": [
		47354,
		7354
	],
	"./書籍・本/Work/図表の掲載位置": [
		98614,
		8614
	],
	"./書籍・本/Work/図表の掲載位置.tsx": [
		98614,
		8614
	],
	"./書籍・本/Work/図表（地図を含む）": [
		9068,
		9068
	],
	"./書籍・本/Work/図表（地図を含む）.tsx": [
		9068,
		9068
	],
	"./書籍・本/Work/文字・文章": [
		59511,
		9511
	],
	"./書籍・本/Work/文字・文章.tsx": [
		59511,
		9511
	],
	"./書籍・本/Work/歌詞・楽譜": [
		74062,
		4062
	],
	"./書籍・本/Work/歌詞・楽譜.tsx": [
		74062,
		4062
	],
	"./書籍・本/Work/立体美術作品": [
		49429,
		9429
	],
	"./書籍・本/Work/立体美術作品.tsx": [
		49429,
		9429
	],
	"./書籍・本/Work/立体美術作品の写真": [
		87607,
		7607
	],
	"./書籍・本/Work/立体美術作品の写真.tsx": [
		87607,
		7607
	],
	"./書籍・本/Work/設問番号又は問題のタイトル": [
		23488,
		3488
	],
	"./書籍・本/Work/設問番号又は問題のタイトル.tsx": [
		23488,
		3488
	],
	"./書籍・本/Work/試験問題【1問】": [
		77712,
		7712
	],
	"./書籍・本/Work/試験問題【1問】.tsx": [
		77712,
		7712
	],
	"./書籍・本/Work/音声のタイトルまたは概要": [
		22117,
		2117
	],
	"./書籍・本/Work/音声のタイトルまたは概要.tsx": [
		22117,
		2117
	],
	"./書籍・本/Work/音声（音楽を含まないもの）": [
		69160,
		9160
	],
	"./書籍・本/Work/音声（音楽を含まないもの）.tsx": [
		69160,
		9160
	],
	"./書籍・本/Work/音楽（ミュージックビデオを含む）": [
		59645,
		9645
	],
	"./書籍・本/Work/音楽（ミュージックビデオを含む）.tsx": [
		59645,
		9645
	],
	"./書籍・本/bigMediaCategory": [
		67655,
		7655
	],
	"./書籍・本/bigMediaCategory.tsx": [
		67655,
		7655
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/Media/サブタイトル、話数": [
		5767,
		5767
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/Media/サブタイトル、話数.tsx": [
		5767,
		5767
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/Work/作品のカテゴリー": [
		89413,
		9413
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/Work/作品のカテゴリー.tsx": [
		89413,
		9413
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/Work/分類未選択": [
		15674,
		5674
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/Work/分類未選択.tsx": [
		15674,
		5674
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/Work/利用した分量": [
		58989,
		8989
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/Work/利用した分量.tsx": [
		58989,
		8989
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/Work/利用箇所": [
		52970,
		2970
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/Work/利用箇所.tsx": [
		52970,
		2970
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/bigMediaCategory": [
		58042,
		8042
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/bigMediaCategory.tsx": [
		58042,
		8042
	],
	"./検定教科書/Media/使用学年": [
		26778,
		6778
	],
	"./検定教科書/Media/使用学年.tsx": [
		26778,
		6778
	],
	"./検定教科書/Media/履修者全員が購入済み": [
		62678,
		2678
	],
	"./検定教科書/Media/履修者全員が購入済み.tsx": [
		62678,
		2678
	],
	"./検定教科書/Media/採択された検定教科書": [
		91937,
		1937
	],
	"./検定教科書/Media/採択された検定教科書 ": [
		47183,
		7183
	],
	"./検定教科書/Media/採択された検定教科書 .tsx": [
		47183,
		7183
	],
	"./検定教科書/Media/採択された検定教科書.tsx": [
		91937,
		1937
	],
	"./検定教科書/Media/検定教科書名": [
		20148,
		148
	],
	"./検定教科書/Media/検定教科書名.tsx": [
		20148,
		148
	],
	"./検定教科書/Media/検定教科書番号から自動入力": [
		93778,
		2164
	],
	"./検定教科書/Media/検定教科書番号から自動入力.tsx": [
		93778,
		2164
	],
	"./検定教科書/Media/検定済年度": [
		20294,
		294
	],
	"./検定教科書/Media/検定済年度.tsx": [
		20294,
		294
	],
	"./検定教科書/SmallMediaCategorys/教科書上からリンクして利用するコンテンツ": [
		14814,
		4814
	],
	"./検定教科書/SmallMediaCategorys/教科書上からリンクして利用するコンテンツ.tsx": [
		14814,
		4814
	],
	"./検定教科書/SmallMediaCategorys/教科書画面上の著作物": [
		63074,
		3074
	],
	"./検定教科書/SmallMediaCategorys/教科書画面上の著作物.tsx": [
		63074,
		3074
	],
	"./検定教科書/SmallMediaCategorys/教科書紙面上の著作物": [
		30970,
		970
	],
	"./検定教科書/SmallMediaCategorys/教科書紙面上の著作物.tsx": [
		30970,
		970
	],
	"./検定教科書/Work/アニメ画像": [
		73859,
		3859
	],
	"./検定教科書/Work/アニメ画像.tsx": [
		73859,
		3859
	],
	"./検定教科書/Work/アーティスト名": [
		53922,
		3922
	],
	"./検定教科書/Work/アーティスト名.tsx": [
		53922,
		3922
	],
	"./検定教科書/Work/イラスト・美術作品": [
		89672,
		9672
	],
	"./検定教科書/Work/イラスト・美術作品.tsx": [
		89672,
		9672
	],
	"./検定教科書/Work/イラスト・美術作品のタイトルまたは概要": [
		66808,
		6808
	],
	"./検定教科書/Work/イラスト・美術作品のタイトルまたは概要.tsx": [
		66808,
		6808
	],
	"./検定教科書/Work/イラスト・美術作品の掲載位置": [
		34462,
		4462
	],
	"./検定教科書/Work/イラスト・美術作品の掲載位置.tsx": [
		34462,
		4462
	],
	"./検定教科書/Work/コンピュータプログラム記述": [
		50668,
		668
	],
	"./検定教科書/Work/コンピュータプログラム記述.tsx": [
		50668,
		668
	],
	"./検定教科書/Work/コンピュータプログラム記述のタイトルまたは概要": [
		51855,
		1855
	],
	"./検定教科書/Work/コンピュータプログラム記述のタイトルまたは概要.tsx": [
		51855,
		1855
	],
	"./検定教科書/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）": [
		28111,
		8111
	],
	"./検定教科書/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）.tsx": [
		28111,
		8111
	],
	"./検定教科書/Work/マンガ": [
		34940,
		4940
	],
	"./検定教科書/Work/マンガ.tsx": [
		34940,
		4940
	],
	"./検定教科書/Work/マンガのタイトルまたは概要": [
		32785,
		2785
	],
	"./検定教科書/Work/マンガのタイトルまたは概要.tsx": [
		32785,
		2785
	],
	"./検定教科書/Work/作品のカテゴリー": [
		35286,
		5286
	],
	"./検定教科書/Work/作品のカテゴリー.tsx": [
		35286,
		5286
	],
	"./検定教科書/Work/写真": [
		32967,
		2967
	],
	"./検定教科書/Work/写真.tsx": [
		32967,
		2967
	],
	"./検定教科書/Work/写真のタイトルまたは概要": [
		62408,
		2408
	],
	"./検定教科書/Work/写真のタイトルまたは概要.tsx": [
		62408,
		2408
	],
	"./検定教科書/Work/写真の掲載位置": [
		59554,
		9554
	],
	"./検定教科書/Work/写真の掲載位置.tsx": [
		59554,
		9554
	],
	"./検定教科書/Work/出典作品名": [
		11850,
		1850
	],
	"./検定教科書/Work/出典作品名.tsx": [
		11850,
		1850
	],
	"./検定教科書/Work/分類未選択": [
		17421,
		7421
	],
	"./検定教科書/Work/分類未選択.tsx": [
		17421,
		7421
	],
	"./検定教科書/Work/利用したアニメ画像を画像ファイルで添付": [
		43422,
		3422
	],
	"./検定教科書/Work/利用したアニメ画像を画像ファイルで添付.tsx": [
		43422,
		3422
	],
	"./検定教科書/Work/利用したイラスト・美術作品を画像ファイルで添付": [
		95126,
		5126
	],
	"./検定教科書/Work/利用したイラスト・美術作品を画像ファイルで添付.tsx": [
		95126,
		5126
	],
	"./検定教科書/Work/利用したマンガを画像ファイルで添付": [
		30755,
		755
	],
	"./検定教科書/Work/利用したマンガを画像ファイルで添付.tsx": [
		30755,
		755
	],
	"./検定教科書/Work/利用した写真を画像ファイルで添付": [
		47309,
		7309
	],
	"./検定教科書/Work/利用した写真を画像ファイルで添付.tsx": [
		47309,
		7309
	],
	"./検定教科書/Work/利用した分量": [
		90706,
		706
	],
	"./検定教科書/Work/利用した分量.tsx": [
		90706,
		706
	],
	"./検定教科書/Work/利用した図表を画像ファイルで添付": [
		40336,
		336
	],
	"./検定教科書/Work/利用した図表を画像ファイルで添付.tsx": [
		40336,
		336
	],
	"./検定教科書/Work/利用箇所": [
		62372,
		2372
	],
	"./検定教科書/Work/利用箇所.tsx": [
		62372,
		2372
	],
	"./検定教科書/Work/動画・映像作品": [
		69321,
		9321
	],
	"./検定教科書/Work/動画・映像作品.tsx": [
		69321,
		9321
	],
	"./検定教科書/Work/図表のタイトル（タイトル不明の場合にはその概要）": [
		27789,
		7789
	],
	"./検定教科書/Work/図表のタイトル（タイトル不明の場合にはその概要）.tsx": [
		27789,
		7789
	],
	"./検定教科書/Work/図表の掲載位置": [
		90316,
		316
	],
	"./検定教科書/Work/図表の掲載位置.tsx": [
		90316,
		316
	],
	"./検定教科書/Work/図表（地図を含む）": [
		33597,
		3597
	],
	"./検定教科書/Work/図表（地図を含む）.tsx": [
		33597,
		3597
	],
	"./検定教科書/Work/文字・文章": [
		10585,
		585
	],
	"./検定教科書/Work/文字・文章.tsx": [
		10585,
		585
	],
	"./検定教科書/Work/歌詞・楽譜": [
		62084,
		2084
	],
	"./検定教科書/Work/歌詞・楽譜.tsx": [
		62084,
		2084
	],
	"./検定教科書/Work/立体美術作品": [
		44221,
		4221
	],
	"./検定教科書/Work/立体美術作品.tsx": [
		44221,
		4221
	],
	"./検定教科書/Work/立体美術作品の写真": [
		17969,
		7969
	],
	"./検定教科書/Work/立体美術作品の写真.tsx": [
		17969,
		7969
	],
	"./検定教科書/Work/翻訳者名（吹替、字幕作品の場合のみ）": [
		20283,
		283
	],
	"./検定教科書/Work/翻訳者名（吹替、字幕作品の場合のみ）.tsx": [
		20283,
		283
	],
	"./検定教科書/Work/設問番号又は問題のタイトル": [
		98777,
		8777
	],
	"./検定教科書/Work/設問番号又は問題のタイトル.tsx": [
		98777,
		8777
	],
	"./検定教科書/Work/試験問題【1問】": [
		27133,
		7133
	],
	"./検定教科書/Work/試験問題【1問】.tsx": [
		27133,
		7133
	],
	"./検定教科書/Work/音声のタイトルまたは概要": [
		37956,
		7956
	],
	"./検定教科書/Work/音声のタイトルまたは概要.tsx": [
		37956,
		7956
	],
	"./検定教科書/Work/音声（音楽を含まないもの）": [
		54646,
		4646
	],
	"./検定教科書/Work/音声（音楽を含まないもの）.tsx": [
		54646,
		4646
	],
	"./検定教科書/Work/音楽": [
		752,
		752
	],
	"./検定教科書/Work/音楽.tsx": [
		752,
		752
	],
	"./検定教科書/Work/音楽（ミュージックビデオを含む）": [
		7371,
		7371
	],
	"./検定教科書/Work/音楽（ミュージックビデオを含む）.tsx": [
		7371,
		7371
	],
	"./検定教科書/bigMediaCategory": [
		14407,
		4407
	],
	"./検定教科書/bigMediaCategory.tsx": [
		14407,
		4407
	],
	"./過去の試験問題/Media/試験名": [
		83947,
		3947
	],
	"./過去の試験問題/Media/試験名.tsx": [
		83947,
		3947
	],
	"./過去の試験問題/Work/アニメ画像": [
		48722,
		8722
	],
	"./過去の試験問題/Work/アニメ画像.tsx": [
		48722,
		8722
	],
	"./過去の試験問題/Work/イラスト・美術作品": [
		66579,
		6579
	],
	"./過去の試験問題/Work/イラスト・美術作品.tsx": [
		66579,
		6579
	],
	"./過去の試験問題/Work/イラスト・美術作品のタイトルまたは概要": [
		17194,
		7194
	],
	"./過去の試験問題/Work/イラスト・美術作品のタイトルまたは概要.tsx": [
		17194,
		7194
	],
	"./過去の試験問題/Work/イラスト・美術作品の掲載位置": [
		34168,
		4168
	],
	"./過去の試験問題/Work/イラスト・美術作品の掲載位置.tsx": [
		34168,
		4168
	],
	"./過去の試験問題/Work/コンピュータプログラム記述": [
		61348,
		1348
	],
	"./過去の試験問題/Work/コンピュータプログラム記述.tsx": [
		61348,
		1348
	],
	"./過去の試験問題/Work/コンピュータプログラム記述のタイトルまたは概要": [
		78528,
		8528
	],
	"./過去の試験問題/Work/コンピュータプログラム記述のタイトルまたは概要.tsx": [
		78528,
		8528
	],
	"./過去の試験問題/Work/マンガ": [
		95564,
		5564
	],
	"./過去の試験問題/Work/マンガ.tsx": [
		95564,
		5564
	],
	"./過去の試験問題/Work/マンガのタイトルまたは概要": [
		82352,
		2352
	],
	"./過去の試験問題/Work/マンガのタイトルまたは概要.tsx": [
		82352,
		2352
	],
	"./過去の試験問題/Work/写真": [
		90318,
		318
	],
	"./過去の試験問題/Work/写真.tsx": [
		90318,
		318
	],
	"./過去の試験問題/Work/写真のタイトルまたは概要": [
		60061,
		61
	],
	"./過去の試験問題/Work/写真のタイトルまたは概要.tsx": [
		60061,
		61
	],
	"./過去の試験問題/Work/写真の掲載位置": [
		87918,
		7918
	],
	"./過去の試験問題/Work/写真の掲載位置.tsx": [
		87918,
		7918
	],
	"./過去の試験問題/Work/分類未選択": [
		28570,
		8570
	],
	"./過去の試験問題/Work/分類未選択.tsx": [
		28570,
		8570
	],
	"./過去の試験問題/Work/利用したアニメ画像を画像ファイルで添付": [
		79639,
		9639
	],
	"./過去の試験問題/Work/利用したアニメ画像を画像ファイルで添付.tsx": [
		79639,
		9639
	],
	"./過去の試験問題/Work/利用したイラスト・美術作品を画像ファイルで添付": [
		64368,
		4368
	],
	"./過去の試験問題/Work/利用したイラスト・美術作品を画像ファイルで添付.tsx": [
		64368,
		4368
	],
	"./過去の試験問題/Work/利用したマンガを画像ファイルで添付": [
		76769,
		6769
	],
	"./過去の試験問題/Work/利用したマンガを画像ファイルで添付.tsx": [
		76769,
		6769
	],
	"./過去の試験問題/Work/利用した写真を画像ファイルで添付": [
		73697,
		3697
	],
	"./過去の試験問題/Work/利用した写真を画像ファイルで添付.tsx": [
		73697,
		3697
	],
	"./過去の試験問題/Work/利用した図表を画像ファイルで添付": [
		63386,
		3386
	],
	"./過去の試験問題/Work/利用した図表を画像ファイルで添付.tsx": [
		63386,
		3386
	],
	"./過去の試験問題/Work/図表の掲載位置": [
		28621,
		8621
	],
	"./過去の試験問題/Work/図表の掲載位置.tsx": [
		28621,
		8621
	],
	"./過去の試験問題/Work/図表（地図を含む）": [
		18929,
		8929
	],
	"./過去の試験問題/Work/図表（地図を含む）.tsx": [
		18929,
		8929
	],
	"./過去の試験問題/Work/文字・文章": [
		19769,
		9769
	],
	"./過去の試験問題/Work/文字・文章.tsx": [
		19769,
		9769
	],
	"./過去の試験問題/Work/歌詞・楽譜": [
		81271,
		1271
	],
	"./過去の試験問題/Work/歌詞・楽譜.tsx": [
		81271,
		1271
	],
	"./過去の試験問題/Work/立体美術作品": [
		83114,
		3114
	],
	"./過去の試験問題/Work/立体美術作品.tsx": [
		83114,
		3114
	],
	"./過去の試験問題/Work/立体美術作品の写真": [
		36775,
		6775
	],
	"./過去の試験問題/Work/立体美術作品の写真.tsx": [
		36775,
		6775
	],
	"./過去の試験問題/bigMediaCategory": [
		91626,
		1626
	],
	"./過去の試験問題/bigMediaCategory.tsx": [
		91626,
		1626
	],
	"./雑誌/Media/DOIコード（論文等の場合）": [
		4163,
		4163
	],
	"./雑誌/Media/DOIコード（論文等の場合）.tsx": [
		4163,
		4163
	],
	"./雑誌/Media/ISSNコード": [
		89668,
		9668
	],
	"./雑誌/Media/ISSNコード.tsx": [
		89668,
		9668
	],
	"./雑誌/Media/利用ページへの直接リンク（URL）またはDOIコード": [
		26796,
		6796
	],
	"./雑誌/Media/利用ページへの直接リンク（URL）またはDOIコード.tsx": [
		26796,
		6796
	],
	"./雑誌/SmallMediaCategorys/Web公開（無料）": [
		21871,
		1871
	],
	"./雑誌/SmallMediaCategorys/Web公開（無料）.tsx": [
		21871,
		1871
	],
	"./雑誌/SmallMediaCategorys/商業誌": [
		30883,
		883
	],
	"./雑誌/SmallMediaCategorys/商業誌.tsx": [
		30883,
		883
	],
	"./雑誌/Work/アニメ画像": [
		11127,
		1127
	],
	"./雑誌/Work/アニメ画像.tsx": [
		11127,
		1127
	],
	"./雑誌/Work/アーティスト名": [
		89214,
		9214
	],
	"./雑誌/Work/アーティスト名.tsx": [
		89214,
		9214
	],
	"./雑誌/Work/イラスト・美術作品": [
		55358,
		5358
	],
	"./雑誌/Work/イラスト・美術作品.tsx": [
		55358,
		5358
	],
	"./雑誌/Work/イラスト・美術作品のタイトルまたは概要": [
		37334,
		7334
	],
	"./雑誌/Work/イラスト・美術作品のタイトルまたは概要.tsx": [
		37334,
		7334
	],
	"./雑誌/Work/イラスト・美術作品の掲載位置": [
		32833,
		2833
	],
	"./雑誌/Work/イラスト・美術作品の掲載位置.tsx": [
		32833,
		2833
	],
	"./雑誌/Work/コンピュータプログラム記述": [
		86293,
		6293
	],
	"./雑誌/Work/コンピュータプログラム記述.tsx": [
		86293,
		6293
	],
	"./雑誌/Work/コンピュータプログラム記述のタイトルまたは概要": [
		2561,
		2561
	],
	"./雑誌/Work/コンピュータプログラム記述のタイトルまたは概要.tsx": [
		2561,
		2561
	],
	"./雑誌/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）": [
		50485,
		485
	],
	"./雑誌/Work/タイトルまたは見出し（作品が複数ある場合は、それぞれ分けて登録してください）.tsx": [
		50485,
		485
	],
	"./雑誌/Work/マンガ": [
		38870,
		8870
	],
	"./雑誌/Work/マンガ.tsx": [
		38870,
		8870
	],
	"./雑誌/Work/マンガのタイトルまたは概要": [
		95288,
		5288
	],
	"./雑誌/Work/マンガのタイトルまたは概要.tsx": [
		95288,
		5288
	],
	"./雑誌/Work/作品のカテゴリー": [
		45062,
		5062
	],
	"./雑誌/Work/作品のカテゴリー.tsx": [
		45062,
		5062
	],
	"./雑誌/Work/写真": [
		61988,
		1988
	],
	"./雑誌/Work/写真.tsx": [
		61988,
		1988
	],
	"./雑誌/Work/写真のタイトルまたは概要": [
		91718,
		1718
	],
	"./雑誌/Work/写真のタイトルまたは概要.tsx": [
		91718,
		1718
	],
	"./雑誌/Work/写真の掲載位置": [
		16230,
		6230
	],
	"./雑誌/Work/写真の掲載位置.tsx": [
		16230,
		6230
	],
	"./雑誌/Work/出典作品名": [
		49560,
		9560
	],
	"./雑誌/Work/出典作品名.tsx": [
		49560,
		9560
	],
	"./雑誌/Work/分類未選択": [
		19875,
		9875
	],
	"./雑誌/Work/分類未選択.tsx": [
		19875,
		9875
	],
	"./雑誌/Work/利用したアニメ画像を画像ファイルで添付": [
		88460,
		8460
	],
	"./雑誌/Work/利用したアニメ画像を画像ファイルで添付.tsx": [
		88460,
		8460
	],
	"./雑誌/Work/利用したイラスト・美術作品を画像ファイルで添付": [
		34189,
		4189
	],
	"./雑誌/Work/利用したイラスト・美術作品を画像ファイルで添付.tsx": [
		34189,
		4189
	],
	"./雑誌/Work/利用したマンガを画像ファイルで添付": [
		23255,
		3255
	],
	"./雑誌/Work/利用したマンガを画像ファイルで添付.tsx": [
		23255,
		3255
	],
	"./雑誌/Work/利用した写真を画像ファイルで添付": [
		887,
		887
	],
	"./雑誌/Work/利用した写真を画像ファイルで添付.tsx": [
		887,
		887
	],
	"./雑誌/Work/利用した分量": [
		12697,
		2697
	],
	"./雑誌/Work/利用した分量.tsx": [
		12697,
		2697
	],
	"./雑誌/Work/利用した図表を画像ファイルで添付": [
		40901,
		901
	],
	"./雑誌/Work/利用した図表を画像ファイルで添付.tsx": [
		40901,
		901
	],
	"./雑誌/Work/利用箇所": [
		6042,
		6042
	],
	"./雑誌/Work/利用箇所.tsx": [
		6042,
		6042
	],
	"./雑誌/Work/動画・映像作品": [
		53744,
		3744
	],
	"./雑誌/Work/動画・映像作品.tsx": [
		53744,
		3744
	],
	"./雑誌/Work/図表のタイトル（タイトル不明の場合にはその概要）": [
		96892,
		6892
	],
	"./雑誌/Work/図表のタイトル（タイトル不明の場合にはその概要）.tsx": [
		96892,
		6892
	],
	"./雑誌/Work/図表の掲載位置": [
		69598,
		9598
	],
	"./雑誌/Work/図表の掲載位置.tsx": [
		69598,
		9598
	],
	"./雑誌/Work/図表（地図を含む）": [
		18540,
		8540
	],
	"./雑誌/Work/図表（地図を含む）.tsx": [
		18540,
		8540
	],
	"./雑誌/Work/文字・文章": [
		86765,
		6765
	],
	"./雑誌/Work/文字・文章.tsx": [
		86765,
		6765
	],
	"./雑誌/Work/歌詞・楽譜": [
		56739,
		6739
	],
	"./雑誌/Work/歌詞・楽譜.tsx": [
		56739,
		6739
	],
	"./雑誌/Work/立体美術作品": [
		80524,
		524
	],
	"./雑誌/Work/立体美術作品.tsx": [
		80524,
		524
	],
	"./雑誌/Work/立体美術作品の写真": [
		63002,
		3002
	],
	"./雑誌/Work/立体美術作品の写真.tsx": [
		63002,
		3002
	],
	"./雑誌/Work/設問番号又は問題のタイトル": [
		14651,
		4651
	],
	"./雑誌/Work/設問番号又は問題のタイトル.tsx": [
		14651,
		4651
	],
	"./雑誌/Work/試験問題【1問】": [
		63397,
		8456
	],
	"./雑誌/Work/試験問題【1問】.tsx": [
		63397,
		8456
	],
	"./雑誌/Work/音声のタイトルまたは概要": [
		68729,
		6155
	],
	"./雑誌/Work/音声のタイトルまたは概要.tsx": [
		68729,
		6155
	],
	"./雑誌/Work/音声（音楽を含まないもの）": [
		86771,
		6771
	],
	"./雑誌/Work/音声（音楽を含まないもの）.tsx": [
		86771,
		6771
	],
	"./雑誌/Work/音楽（ミュージックビデオを含む）": [
		18436,
		8436
	],
	"./雑誌/Work/音楽（ミュージックビデオを含む）.tsx": [
		18436,
		8436
	],
	"./雑誌/bigMediaCategory": [
		80117,
		117
	],
	"./雑誌/bigMediaCategory.tsx": [
		80117,
		117
	],
	"./音楽/Media/アルバム・シングルのタイトル": [
		88592,
		8592
	],
	"./音楽/Media/アルバム・シングルのタイトル.tsx": [
		88592,
		8592
	],
	"./音楽/Media/アーティスト名": [
		55030,
		5030
	],
	"./音楽/Media/アーティスト名.tsx": [
		55030,
		5030
	],
	"./音楽/Media/レコード商品番号": [
		44099,
		4099
	],
	"./音楽/Media/レコード商品番号.tsx": [
		44099,
		4099
	],
	"./音楽/Work/アーティスト名": [
		49508,
		9508
	],
	"./音楽/Work/アーティスト名.tsx": [
		49508,
		9508
	],
	"./音楽/Work/分類未選択": [
		95482,
		5482
	],
	"./音楽/Work/分類未選択.tsx": [
		95482,
		5482
	],
	"./音楽/bigMediaCategory": [
		69011,
		9011
	],
	"./音楽/bigMediaCategory.tsx": [
		69011,
		9011
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4561;
module.exports = webpackAsyncContext;